import styled from 'styled-components';

import Help_people_list_icon from "../../../assests/images/help_people_list_icon.svg";


export const AboutSection = styled.section`
    background: #F1FEFF 0% 0% no-repeat padding-box;

    @media screen and (max-width: 575px){
        padding-bottom: 40px;
    }
`;

export const AboutText = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 15px;
    padding: 30px;
    position: relative;
    top: -120px;    

    @media screen and (max-width: 767px){
        padding: 20px;
    }
    @media screen and (max-width: 575px){
        padding: 15px 15px 5px;
    }
`;
export const AboutTitle = styled.h2`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:30px;
    font-weight:700;
    line-height: 43px;
    margin-bottom: 15px;

    @media screen and (max-width: 1024px){ 
        font-size:26px;
        line-height: 38px;
    }
    @media screen and (max-width: 767px){ 
        font-size:24px;
        line-height: 36px;
    }
`;

export const AboutSmallText = styled.p`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight:400;
    line-height: 27px;
    margin-bottom: 21px;
    
    @media screen and (max-width: 575px){ 
        font-size:16px;
        line-height: 24px;
        margin-bottom: 20px;
    }
`;

export const AboutList = styled.ul`
    padding: 0;
    margin: 0 0 20px 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
`;

export const AboutItem = styled.li`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight:400;
    line-height: 27px;
    display: flex;
    gap: 10px;
    align-items: center;
    width: 100%;
    position: relative;
    padding-left: 30px;

    @media screen and (max-width: 575px){
        padding-left: 27px;
        font-size:16px;
        line-height: 24px;
    }

    &::before{
        content: '';
        position: absolute;
        background: url(${Help_people_list_icon});
        background-repeat: no-repeat;
        background-position: left top;
        background-size: contain;
        width: 20px;
        height: 20px;
        top: 2px;
        left: 0;

        @media screen and (max-width: 575px){ 
            width: 17px;
            height: 17px;
            top: 5px;
        }
    }
`;

export const NeedSection = styled.div`
    padding-bottom:50px;
    margin-top: -70px;

    @media screen and (max-width: 575px){
        margin-top: -78px;px;
        padding-bottom: 40px;
    }
`;


export const NeedTitle = styled.h3`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:30px;
    font-weight:700;
    line-height: 43px;
    margin-bottom: 15px;

    @media screen and (max-width: 1024px){ 
        font-size:26px;
        line-height: 38px;
    }
    @media screen and (max-width: 767px){ 
        font-size:24px;
        line-height: 36px;
    }

    @media screen and (max-width: 575px){
        margin-bottom: 15px;
    }
`;
export const FounderNeed = styled.div`
    display: flex;
    align-items: center;
    gap:20px;
    
    @media screen and (max-width: 575px){
        flex-direction: column;
        row-gap: 20px;
    }

`;

export const FounderImage = styled.div`
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 10px;
`;

export const FounderText = styled.div`

`;

export const FounderSmallText = styled.span`
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight:600;
    line-height:27px;
    display:block;
    margin-bottom: 10px;
    
    @media screen and (max-width: 575px){
        font-size:18px;
        line-height:24px;
    }
`;

export const FounderDesignation = styled.span`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight:400;
    line-height:27px;
`;

export const OpportunitySection = styled.div`
    padding-bottom:29px;

    @media screen and (max-width: 575px){ 
        padding-bottom: 0px;
    }
`;
